/* =====================================================================
   REGISTA — THEME BUG FIXES
   ---------------------------------------------------------------------
   Deliberately NOT scoped to body.rg-redesign. These repair broken theme
   behaviour and should keep working even if the header/footer redesign
   is switched off.

   ---------------------------------------------------------------------
   1. Dead close ("X") buttons on every dialog
   ---------------------------------------------------------------------
   The theme's markup uses a CUSTOMIZED BUILT-IN element:

       <button type="button" is="dialog-close-button">

   For that to work, the class has to extend HTMLButtonElement and be
   registered with the third argument:

       customElements.define('dialog-close-button', Cls, { extends: 'button' })

   assets/theme.js does neither. It declares

       var DialogCloseButton = class extends HTMLElement { ... }
       customElements.define('dialog-close-button', DialogCloseButton)

   i.e. an AUTONOMOUS element named <dialog-close-button>. There is no
   <dialog-close-button> tag anywhere in the theme, and there are zero
   `extends:` registrations in theme.js, so nothing ever upgrades those
   buttons. Their constructor never runs, the click listener it would
   have attached never exists, and the "dialog:force-close" event that
   DialogElement listens for is never dispatched.

   That single mismatch is why the X does nothing on the search overlay,
   the mobile menu drawer, the collection filter drawer, the quick-buy
   modal, the newsletter pop-up and the privacy banner. Clicking outside
   still worked because that is a separate code path.

   The name 'dialog-close-button' is already taken in the registry, so it
   cannot simply be re-registered correctly -- a second define() with the
   same name throws. This delegates instead: one capturing listener on
   the document, dispatching exactly the event DialogElement expects.

   Clicks are composed, so composedPath() sees buttons inside Shadow DOM
   (the menu and filter drawers keep theirs there) and the dispatched
   event is composed too, so it crosses back out to the dialog host.

   If the underlying theme bug is ever fixed upstream, the guard below
   makes this a no-op rather than a double-close.
   ===================================================================== */

(function () {
  'use strict';

  var SELECTOR = '[is="dialog-close-button"]';
  var EVENT = 'dialog:force-close';

  function isUpgraded(node) {
    var Ctor = window.customElements && window.customElements.get('dialog-close-button');
    return !!(Ctor && node instanceof Ctor);
  }

  document.addEventListener(
    'click',
    function (event) {
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];

      for (var i = 0; i < path.length; i++) {
        var node = path[i];

        if (!node || node.nodeType !== 1 || typeof node.matches !== 'function') continue;
        if (!node.matches(SELECTOR)) continue;

        // Already working on its own: leave it alone.
        if (isUpgraded(node)) return;

        node.dispatchEvent(
          new CustomEvent(EVENT, { bubbles: true, cancelable: true, composed: true })
        );
        return;
      }
    },
    true
  );
})();
